
import { defineComponent, reactive, ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import ManufMethodMgmt from "@/components/ManufMethodMgmt.vue";
import SiteMgmt from "@/components/SiteMgmt.vue";

export default defineComponent({
  components: {
    ManufMethodMgmt,
    SiteMgmt,
  },
  setup() {
    //#region
    const { t } = useI18n();

    const state = reactive({
      activeTabName: "manufMehtod" as "manufMehtod" | "sites",
    });
    //#endregion

    //#region Ref
    /* 工藝類別 Ref */
    const ManufMethodMgmtRef = ref(ManufMethodMgmt);

    /* 廠區 Ref */
    const SiteMgmtRef = ref(SiteMgmt);
    //#endregion

    //#region UI Events
    const OnTabChanged = () => {
      switch (state.activeTabName) {
        case "manufMehtod":
          /* refresh ManufMethodMgmt */
          ManufMethodMgmtRef.value?.onTabSelected();
          break;
        case "sites":
          /* refresh SiteMgmt */
          SiteMgmtRef.value?.onTabSelected();
          break;
        default:
          break;
      }
    };
    //#endregion

    return {
      ...toRefs(state),
      t,

      /* Ref */
      ManufMethodMgmtRef,
      SiteMgmtRef,

      /* UI Events */
      OnTabChanged,
    };
  },
});
